export default __webpack_public_path__ + "static/media/incoming-white.b9678555.svg";